import React, { useState, useEffect } from "react";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Button, Empty, Table } from 'antd';
import BrokerService from "../../../services/broker.service";
import { Badge } from 'react-bootstrap';
import moment from 'moment';
import LoderCom from "../../common/Loder";
import { RefreshCw } from 'lucide-react';
import { setSubscriptions as setSubscriptionsAction } from "../../../redux/actions/packageAction";
import { useDispatch } from "react-redux";
import { useToast } from "components/common/custom-toast/Toast";

const Subscriptions = () => {
    const [subscriptions, setSubscriptions] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const toast = useToast()

    const columns2 = [
        {
            title: 'Purchased At',
            dataIndex: 'time',
            key: 'time',
            responsive: ['md'],
            width: "170px",
            render: (_, row) => {
                return (
                    <label className="text-start ">{moment(row.time).format('y-M-DD HH:mm:ss')}</label>
                )
            },
        },
        {
            title: 'Product',
            dataIndex: 'productType',
            key: 'productType',
            render: (_, row) => {
                return (
                    <label className="text-start">
                        {row.productType === 'qt-new' ? (
                            <><span className="quik">Quik</span><span className="trade">Trade</span></>
                        ) : row.productType === 'sip' ? (
                            <span className="trade">Static IP</span>
                        ) : (
                            <span className="quik">Discover</span>
                        )}
                    </label>
                );
            },
        },
        {
            title: 'Plan Type',
            dataIndex: 'planType',
            key: 'planType',
            align: "left",
            render: (_, row) => {
                return (
                    <label className="text-start" >{row?.planType}</label>
                );
            },
        },

        {
            title: 'Start Date',
            dataIndex: 'packageStartTime',
            key: 'packageStartTime',
            width: "170px",
            render: (_, row) => {
                return (
                    <label>{(row.packageStartTime) ? moment(row.packageStartTime).format('DD-MM-YYYY') : ''}</label>
                )
            },
        },

        {
            title: 'End Date',
            dataIndex: 'packageEndTime',
            key: 'packageEndTime',
            width: "170px",
            render: (_, row) => {
                return (
                    <label>{(row.packageEndTime) ? moment(row.packageEndTime).format('DD-MM-YYYY') : ''}</label>
                )
            },
        },
        {
            title: 'Validity',
            dataIndex: 'validDays',
            key: 'validDays',
            width: "170px",
            render: (_, row) => {
                return (
                    <label>{row.validDays} Days</label>
                )
            },
        },

        {
            title: 'Validity Status',
            dataIndex: 'validDays',
            key: 'validDays',
            width: "170px",
            render: (_, row) => {
                const hasDate = !!row.packageEndTime;
                const isExpired = hasDate && moment().isAfter(moment(row.packageEndTime));
                const isValid = hasDate && !isExpired;
                const isUnavailable = !hasDate || isNaN(moment(row.packageEndTime).valueOf());

                return (
                    <Badge 
                        style={isValid ? { paddingLeft: "15px", paddingRight: "15px" } : isUnavailable ? { paddingLeft: "17px", paddingRight: "17px" } : {}} 
                        bg={isValid ? "success" : isUnavailable ? "secondary" : "danger"} 
                        className="ms-2 soft-ba"
                    >
                        {isValid ? "Valid" : isUnavailable ? "N/A" : "Expired"}
                    </Badge>
                )
            },
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (_, row) => {
                return (
                    <label >₹{row.amount}</label>
                )
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (_, row) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Badge style={{ width: "63px" }} bg={row.status == "pending" ? "secondary" : "success"} size="lg" className="soft-ba">
                            {row.status == "pending" ? "Initiated" : row.status.charAt(0).toUpperCase() + row.status.slice(1)}
                        </Badge>
                        <Button
                            onClick={() => handleSyncSubscription(row.razorpayOrderId)}
                        >
                            <RefreshCw size={16} />
                        </Button>
                    </div>
                );
            },
        },
    ];

    const handleSyncSubscription = async (orderId) => {
        try {
            await BrokerService.syncSubscriptionStatus(orderId);
            getSuscriptions();
            toast.success('Subscription status updated successfully');
        } catch (error) {
            console.error('Error syncing subscription status:', error);
            toast.error('Failed to update subscription status');
        }
    };

    const getSuscriptions = () => {
        setLoading(true);
        BrokerService.getSuscriptions().then(
            response => {
                setLoading(false);
                if (response.code === 200) {
                    if (response.data && response.data.payments) {
                        const quikTradeSubscriptions = response.data.payments.filter(subscription =>
                            subscription.productType === 'qt-new' || subscription.productType === 'sip'
                        );
                        setSubscriptions(quikTradeSubscriptions);
                        dispatch(setSubscriptionsAction(quikTradeSubscriptions))
                    } else {
                        setErrorMessage("No Subscriptions");
                    }
                } else {
                    toast.error('Session expired');
                }
            },
            error => {
                setLoading(false);
                setErrorMessage((error.response && error.response.data) ||
                    error.message ||
                    error.toString()
                );
            }
        );
    };

    useEffect(() => {
        getSuscriptions();
    }, []);

    if (loading) {
        return <LoderCom size="large" />;
    }

    if (errorMessage) {
        return (
            <div className="p-3">
                <p>{errorMessage}</p>
            </div>
        );
    }

    return (
        <div style={{ height: 'calc(100vh - 50px)', overflowY: 'auto', padding: "1.25rem" }}>
            <Row>
                <Col md={12}>
                    <Table
                        locale={{
                            emptyText: (
                                <Empty
                                    className="mt-3 mb-3"
                                    description="No subscriptions"
                                />
                            )
                        }}
                        rowKey="id"
                        className="sub-table"
                        pagination={false}
                        columns={columns2}
                        dataSource={subscriptions}
                        scroll={{ x: true }}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default Subscriptions;




